<template lang="pug">
#modal-smartcard.modal.modal-lg.fade(tabindex='-1')
  .modal-dialog
    .modal-content
      .modal-header
        button.btn-close(
          type='button',
          data-bs-dismiss='modal',
          aria-label='Fechar'
        )
      .modal-body
        h4(v-show='stepModal === 1 || stepModal === 2') Vamos te ajudar a fazer o download do Driver referente ao seu Smartcard!
        h4(v-show='stepModal === 3') Aguarde enquanto o download é concluído
        ul.nav.nav--wizard.my-4.d-flex.flex-row.justify-content-center(
          v-if='stepModal !== 3'
        )
          li.nav-item(
            :class='[stepModal === 2 ? "nav--wizard__nav-item--success" : ""]'
          )
            a.nav-link(
              content='1',
              :class='[stepModal === 1 ? "active" : "", stepModal === 2 ? "disabled" : ""]'
            ) Selecione o modelo do Chip
          li.nav-item
            a.nav-link(content='2', :class='[stepModal === 2 ? "active" : ""]') Selecione o Sistema Operacional
        .smartcard-choice(v-if='stepModal === 1')
          p Em qual Smartcard está armazenado seu Certificado Digital?
          .form-smartcard.d-flex.flex-row.justify-content-center
            .form-check
              input#radioAWP.form-check-input.form-check-input--success(
                type='radio',
                name='radioSmartcard',
                value='AWP',
                v-model='smartcardChoice',
                checked=''
              )
              label.form-check-label(for='radioAWP')
                | AWP
            .form-check.ms-3
              input#radioGEMALTO.form-check-input.form-check-input--success(
                type='radio',
                name='radioSmartcard',
                value='GEMALTO',
                v-model='smartcardChoice'
              )
              label.form-check-label(for='radioGEMALTO')
                | GEMALTO
            .form-check.ms-3
              input#radioMORPHO.form-check-input.form-check-input--success(
                type='radio',
                name='radioSmartcard',
                value='MORPHO',
                v-model='smartcardChoice'
              )
              label.form-check-label(for='radioMORPHO')
                | MORPHO
          p.mt-2 Compare o #[strong Chip e o verso] do seu smart card para selecionar o driver correto
          .smarcard-choice-radio
            .awp-choice(v-show='smartcardChoice === \'AWP\'')
              p IDEMIA
              .images-idemia-card.d-flex.flex-row.justify-content-center
                .images-idemia-card__frontside.d-flex.flex-column
                  span.text-start.ms-3 Frente
                  img(
                    src='@/assets/images/frenteIdemia.svg',
                    alt='Imagem de um card IDEMIA'
                  )
                .images-idemia-card__backside.d-flex.flex-column
                  span.text-start.ms-3 Verso
                  img(
                    src='@/assets/images/versoIdemia.svg',
                    alt='Imagem de um card IDEMIA'
                  )
                  span#tooltip-idemia(
                    data-bs-toggle='tooltip',
                    data-bs-placement='bottom',
                    data-bs-custom-class='custom-tooltip',
                    data-bs-title='IDEMIA 2 - 9999999X9 - 99/99',
                    @mouseover='createTooltip("#tooltip-idemia")'
                  ) AAAAAAA
              p.mt-2 OT
              .images-ot-card.d-flex.flex-row.justify-content-center
                .images-ot-card__frontside.d-flex.flex-column
                  span.text-start.ms-3 Frente
                  img(
                    src='@/assets/images/frenteOT.svg',
                    alt='Imagem de um card IDEMIA'
                  )
                .images-ot-card__backside.d-flex.flex-column
                  span.text-start.ms-3 Verso
                  img(
                    src='@/assets/images/versoOT.svg',
                    alt='Imagem de um card IDEMIA'
                  )
                  span#tooltip-ot(
                    data-bs-toggle='tooltip',
                    data-bs-placement='right',
                    data-bs-custom-class='custom-tooltip',
                    data-bs-title='OT. 99999XX999999999 - 99/99',
                    @mouseover='createTooltip("#tooltip-ot")'
                  ) AAAAAAA
            .gemalto-choice(v-show='smartcardChoice === \'GEMALTO\'')
              .images-gemalto-card.d-flex.flex-row.justify-content-center.mt-4
                .images-gemalto-card__frontside.d-flex.flex-column
                  span.text-start.ms-3 Frente
                  img(
                    src='@/assets/images/frenteGemalto.svg',
                    alt='Imagem de um card GEMALTO'
                  )
                .images-gemalto-card__backside.d-flex.flex-column
                  span.text-start.ms-3 Verso
                  img(
                    src='@/assets/images/versoGemalto.svg',
                    alt='Imagem de um card GEMALTO'
                  )
                  span#tooltip-gemalto(
                    data-bs-toggle='tooltip',
                    data-bs-placement='left',
                    data-bs-custom-class='custom-tooltip',
                    data-bs-title='gemalto xxxX9999999X9999',
                    @mouseover='createTooltip("#tooltip-gemalto")'
                  ) AAAAAAA
            .morpho-choice(v-show='smartcardChoice === \'MORPHO\'')
              .images-morpho-card.d-flex.flex-row.justify-content-center.mt-4
                .images-morpho-card__frontside.d-flex.flex-column
                  span.text-start.ms-3 Frente
                  img(
                    src='@/assets/images/frenteMorpho.svg',
                    alt='Imagem de um card MORPHO'
                  )
                .images-gemalto-card__backside.d-flex.flex-column
                  span.text-start.ms-3 Verso
                  img(
                    src='@/assets/images/versoMorpho.svg',
                    alt='Imagem de um card MORPHO'
                  )
                  span#tooltip-morpho(
                    data-bs-toggle='tooltip',
                    data-bs-placement='right',
                    data-bs-custom-class='custom-tooltip',
                    data-bs-title='Morpho 99/99',
                    @mouseover='createTooltip("#tooltip-morpho")'
                  ) AAAAA
        .os-choice(v-if='stepModal === 2')
          p Escolha abaixo o Sistema Operacional do seu computador
          .os-choice__images.d-flex.flex-row.justify-content-center.align-items-center.my-5
            a(
              type='button',
              @click='operationalSystem = "windowsOSSelected"',
              data-bs-toggle='tooltip',
              data-bs-placement='bottom',
              data-bs-title='windows'
            )
              img(:src='windowsChecked', alt='Logo do Windows')
            a.mx-5(type='button', @click='operationalSystem = "macOSSelected"')
              img(:src='macChecked', alt='Logo do MacOS')
            a(type='button', @click='operationalSystem = "linuxOSSelected"')
              img(:src='linuxChecked', alt='Logo do Linux')
          .driver-choice.d-flex.flex-column
            p.text-start(v-if='drivers.length > 0') Agora selecione a Versão
            Selectable(
              :options='drivers',
              v-show='drivers.length > 0',
              label='',
              name='index',
              icon='download',
              labelSelectable='nome',
              placeholder='Selecione o driver desejado',
              v-model='driverChoice',
              :key='selectableCount'
            )
        .final-modal-smartcard.d-flex.flex-column.justify-content-center(
          v-if='stepModal === 3'
        )
          .d-flex.flex-row.justify-content-center
            img.my-3(
              src='../../assets/images/download.gif',
              alt='Gif animado de download'
            )
          p.text-start.my-3 #[strong Importante]
          p.text-start.d-flex.flex-row
            Icon.icon-check(name='circle-check')
            span Enquanto isso, certifique-se de que sua mídia esteja #[strong desconectada] do seu computador para prosseguir com a instalação.
          p.text-start.d-flex.flex-row
            Icon.icon-check(name='circle-check')
            span Após a conclusão do Download, execute o arquivo instalado e avance as etapas até concluir a instalação do programa.
          p.text-start.d-flex.flex-row
            Icon.icon-check(name='circle-check')
            span Após a instalação do programa, #[strong insira a mídia na leitora.]
          p.text-start.d-flex.flex-row
            Icon.icon-check(name='circle-check')
            span Em seguida, #[a(:href='getLinkEmissor') faça o download do emissor] e siga os passos até a conclusão da instalação e a gravação dos dados do Certificado Digital em sua mídia.

      .modal-footer
        .row
          p.col-5.text-danger.text-start(v-if='hasDriversAndNoHasOS') Não há driver encontrado para este Sistema Operacional
          .text-end(:class='hasDriversAndNoHasOS ? "col-7" : "col-12"')
            button.me-3.btn.btn-outline-primary(
              v-if='stepModal === 2',
              type='button',
              @click='stepModal--'
            ) Voltar
            button.btn.btn-primary(
              v-if='stepModal === 1',
              @click='stepModal++',
              type='button'
            )
              span Avançar
              Icon.ms-2(name='arrow-right')
            button.btn.btn-primary(
              :href='link',
              v-if='stepModal === 2',
              :class='!hasDriversAndStepTwo && driverChoice === "" ? "btn-secondary" : "btn-primary"',
              :disabled='!hasDriversAndStepTwo',
              type='button',
              @click='downloadDriver'
            )
              span Fazer download do drive
              Icon.ms-2(name='download')
            a.me-3.link.btn.btn-outline-primary(
              v-if='stepModal === 3',
              type='button',
              href='/ManualEmissaoA3.pdf',
              target='_blank'
            )
              Icon.me-2(name='up-right-from-square')
              span Abrir guia de instalação
            a.btn.btn-primary(
              v-if='stepModal === 3',
              type='button',
              :href='getLinkEmissor',
              target='_blank'
            )
              span Baixar emissor
              Icon.ms-2(name='download')

button.btn-desktop.btn.btn-primary.mt-3(
  type='button',
  data-bs-target='#modal-smartcard',
  data-bs-toggle='modal',
  @click='stepModal = 1'
)
  Icon.me-2(name='download')
  span Baixar driver
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import Icon from '@/components/Atoms/Icon.vue'
  import Selectable from '@/components/Atoms/Selectable.vue'
  import driversSmartcardJson from '@/store/JSON/driversSmartcardJson'
  import { mapState } from 'pinia'
  import { useAR } from '@/store/Pinia/useAR.store'
  import * as bootstrap from 'bootstrap'

  import windowsOSImg from '@/assets/images/windows-black.svg'
  import windowsOSSelectedImg from '@/assets/images/windows-blue.svg'
  import macOSImg from '@/assets/images/mac-black.svg'
  import macOSSelectedImg from '@/assets/images/mac-blue.svg'
  import linuxOSImg from '@/assets/images/linux-black-eo.svg'
  import linuxOSSelectedImg from '@/assets/images/linux-blue.svg'

  interface IObjectDrive {
    nome: string
    link: string
    type: string
  }

  export default defineComponent({
    name: 'ModalSmartCardComponent',
    components: {
      Icon,
      Selectable,
    },
    data: () => ({
      stepModal: 1,
      smartcardChoice: 'AWP',
      operationalSystem: '',
      windowsOS: windowsOSImg,
      windowsOSSelected: windowsOSSelectedImg,
      macOS: macOSImg,
      macOSSelected: macOSSelectedImg,
      linuxOS: linuxOSImg,
      linuxOSSelected: linuxOSSelectedImg,
      driverChoice: '',
      link: '',
      selectableCount: 0,
      drivers: [],
    }),
    methods: {
      downloadDriver() {
        window.open(this.link)
        this.stepModal += 1
      },
      createTooltip(id: string) {
        const tooltip = new bootstrap.Tooltip(id)
        tooltip.show()
      },
    },
    // eslint-disable-next-line vue/order-in-components
    computed: {
      ...mapState(useAR, ['getLinkEmissor']),
      windowsChecked() {
        if (this.operationalSystem === 'windowsOSSelected') {
          return this.windowsOSSelected
        }
        return this.windowsOS
      },
      macChecked() {
        if (this.operationalSystem === 'macOSSelected') {
          return this.macOSSelected
        }
        return this.macOS
      },
      linuxChecked() {
        if (this.operationalSystem === 'linuxOSSelected') {
          return this.linuxOSSelected
        }
        return this.linuxOS
      },
      hasDriversAndStepTwo() {
        return this.drivers.length > 0 && this.stepModal === 2
      },
      hasDriversAndNoHasOS() {
        return this.drivers.length === 0 && this.operationalSystem !== ''
      },
    },
    // eslint-disable-next-line vue/order-in-components
    watch: {
      stepModal(curr: number) {
        if (curr === 1) {
          this.operationalSystem = ''
          this.drivers = []
        }
      },
      operationalSystem(
        current: 'linuxOSSelected' | 'macOSSelected' | 'windowsOSSelected',
      ) {
        if (current) {
          const drivers = driversSmartcardJson[current]
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          this.drivers = drivers.filter(
            (x) => x.type === this.smartcardChoice,
          ) as any
          this.selectableCount += 1
          this.driverChoice = ''
        }
      },
      driverChoice(current) {
        const objectDrive = this.drivers.find(
          (x: IObjectDrive) => x.nome === current,
        ) as IObjectDrive | undefined
        if (objectDrive) {
          this.link = objectDrive.link
        }
      },
    },
  })
</script>

<style lang="stylus" scoped>
  #tooltip-idemia
    font-size: 12px
    position: absolute
    right: 242px
    bottom: 290px
    opacity: 0
  #tooltip-ot
    font-size: 12px
    position: absolute
    right: 152px
    bottom: 45px
    opacity: 0
  #tooltip-gemalto
    font-size: 12px
    position: absolute
    right: 130px
    bottom: 155px
    opacity: 0
    transform: rotate(90deg)
  #tooltip-morpho
    font-size: 12px
    position: absolute
    right: 350px
    bottom: 180px
    opacity: 0
  .final-modal-smartcard
    span
      a
        text-decoration: underline
        font-weight: 700
  .smarcard-choice
    span
      font-size: 14px
      font-weight: 400
  .icon-check
    color: var(--color-success-600)
    margin-right: 0.5rem
  .btn-desktop
    display: block !important

  @media screen and (max-width: 768px)
    .btn-desktop
      display: none !important
</style>
